module.exports = __webpack_public_path__ + "img/logo.49752a85.png";